export const FEATURE_FLAGS = {
  // Register every flag key here. Match exactly what's in the LD dashboard.
  // EXAMPLE: SHOW_NEW_RELEASE_FORM: 'show-new-release-form',
  // d84760a3-ca97-fff1-fff1-5bdd25f870b1--d82582fa-111b-fff1-fff1-5bdd25f8aa02
  APP_ADMIN_TOOL_DASHBOARD: "APP_ADMIN_TOOL_DASHBOARD",
  // PLC Modernization workspace (APRS / DTRAN-46470). Gates the PLCs menu +
  // /plc routes. Admin-only in addition to this flag.
  ENABLE_PLC_WORKSPACE: "ENABLE_PLC_WORKSPACE",
  // Submit release → Configure Targets (DTRAN-51514): full modern targeting UI
  // (recommendations, batch add, Selected targets). When off, pre-51514 legacy UI.
  ENABLE_TARGET_RECOMMENDATIONS: "ENABLE_TARGET_RECOMMENDATIONS"
} as const;
